
const VideoLink = () => (
  <div className="ratio ratio-4x3 mb-3">
    <iframe src="https://www.youtube.com/embed/T99uLQoYPaw" title="YouTube video" ></iframe>
  </div>
);

export default VideoLink;
